import { Component, ElementRef, Input, NgZone, OnInit, ViewChild, forwardRef } from '@angular/core';
import { TransactionService } from '../../../services/transaction.service';
import { ConstantService } from '../../../constant/constant-service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AvStationsComponent } from '../../av-stations/av-stations.component';
import { environment } from '../../../../environments/environment';
import { User } from '../../../model/user';
import { AuthService } from '../../../services/auth.service';

export const AV_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AvStationsComponent),
  multi: true,
};

@Component({
  selector: 'av-stations-prev',
  templateUrl: './av-stations-prev.component.html',
  styleUrls: ['./av-stations-prev.component.scss']
})
export class AvStationsPrevComponent implements OnInit {

  @Input() label: string;
  @Input() options: Array<{ label: string; value: any }>;
  @Input() disabled = false;
  @Input() filter = true;
  @Input() active: boolean = true;
  @Input() principal: boolean = true;
  @Input() selectionLabel: string;
  @ViewChild('input') inputRef: ElementRef;
  user:User;
  selectionStation: any;
  stations: any[];

  constructor(private zone: NgZone, private authService: AuthService, private transactionService: TransactionService, private constantService: ConstantService) {

    this.user = this.authService.currentUserValue;
  }

  ngOnInit(): void {
    this.user = this.authService.currentUserValue;

    if(!this.user)
      window.location.reload();

    if(!this.stations)
      this.getStation(this.user.id);
  }

  getStation(userId:number) {

    this.transactionService.GetList(environment.adminAPI, this.constantService.USER_STATION_URL, '/GetStationUser/' + this.active + '/' + userId).subscribe(
      (data) => {
        this.stations = data.businessDto;
        if (data.responseDto.response === this.constantService.RESPONSE_OK) {
          this.options = new Array();
          for (let index = 0; index < data.businessDto.length; index++) {
            this.options.push({ label: data.businessDto[index].stationDesc, value: data.businessDto[index].stationId });
          }

          this.setDefaultStation(this.options[0]);
        }
      },
      (error) => {
        console.debug('Error: ' + error);
      }
    );
  }

  setDefaultStation(options: any){
    if(!localStorage.getItem('station')){
      this.stations.forEach(station => { if(station.stationId == options.value) localStorage.setItem('station',JSON.stringify(station.station))})
      this.selectionStation = options;
    }else{
      this.options.forEach(option => {
        if(option.value == JSON.parse(localStorage.getItem('station')).id){
          this.selectionStation = option
        }
      });
    }
  }

  propagateChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.selectionStation = value;
  }
  onChange(): void {
    this.zone.run(() => {
      this.propagateChange(this.selectionStation.value);
      this.stations.forEach(station => { if(station.stationId == this.selectionStation.value) localStorage.setItem('station',JSON.stringify(station.station))})
      window.location.reload()
    });
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getStationOnClick(){
    if(!this.stations){
      console.log('Click en select');
      this.getStation(this.user.id)
    }
  }

}
